import Layout from "../Layout";
import * as XLSX from "sheetjs-style";
import {
  FaRegCalendarAlt,
  FaCreditCard,
  FaRegClock,
  FaLongArrowAltLeft,
  FaFilePdf,
  FaFileExcel,
} from "react-icons/fa";
import {
  PiNotebookBold,
  PiTicketBold,
  PiHandWithdrawBold,
} from "react-icons/pi";
import { AiOutlineDollar } from "react-icons/ai";
import { RiDoorClosedLine } from "react-icons/ri";
import { useState, useEffect } from "react";
import { FaFilter } from "react-icons/fa6";

import axios from "axios";

import Loader from "../Layout/loader";
import Fechamento from "../Relatorios/fechamento";
import VendasPeriodo from "../Relatorios/vendasPeriodo";
import VendasTurnoPDV from "../Relatorios/vendasTurnoPDV";
import VendasCardapio from "../Relatorios/vendasCardapio";
import ConsumoCartao from "../Relatorios/consumoCartao";
import VendasPagamento from "../Relatorios/vendasPagamento";
import VendasIngressos from "../Relatorios/vendasIngressos";
import RetiradaReforco from "../Relatorios/retiradaReforco";

import { codigoEvento, formatDateTimeLocal } from "../Utils/utils";

import { pdf } from "@react-pdf/renderer";
import FechamentoPDF from "./pdfs/fechamentoPDF";
import VendasPeriodoPDF from "./pdfs/vendasPeriodoPDF";
import VendasTurnoPDF from "./pdfs/vendasTurnoPDF";
import VendasCardapioPDF from "./pdfs/vendasCardapioPDF";
import ConsumoCartaoPDF from "./pdfs/consumoCartaoPDF";
import VendasPagamentoPDF from "./pdfs/vendasPagamentoPDF";
import RetiradaReforcoPDF from "./pdfs/retiradaReforcoPDF";
import VendasIngressosPDF from "./pdfs/vendasIngressosPDF";

function Relatorios() {
  const pad = (n) => String(n).padStart(2, "0");

  useEffect(() => {
    const dataFormatada =
      agora.getFullYear() +
      "-" +
      pad(agora.getMonth() + 1) +
      "-" +
      pad(agora.getDate());

    setdataInicial(dataFormatada + "T00:00");
    setDataFim(dataFormatada + "T23:59");

    axios
      .get(`${process.env.REACT_APP_API_URL}/Cardapio`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((res) => {
        if (res.status === 200) {
          let cardapios = res.data.map((item) => {
            return {
              label: `${item.CODIGO} - ${item.DESCRICAO}`,
              value: item.CODIGO,
            };
          });
          setMenuOptions(cardapios);
        }
      });
  }, []);

  // STATE VARIABLES
  const [selectedReport, setSelectedReport] = useState(null);
  const [reportName, setReportName] = useState("");
  const [showReportData, setShowReportData] = useState(false);
  const [reportData, setReportData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [menuOptions, setMenuOptions] = useState([]);
  const [busca, setBusca] = useState("");
  const [aberto, setAberto] = useState(false);
  const [error, setError] = useState(false);

  // INPUT DATA
  const agora = new Date();

  const [dataInicial, setdataInicial] = useState(
    agora.getFullYear() +
      "-" +
      agora.getMonth() +
      "-" +
      agora.getDate() +
      "T00:00"
  );
  const [dataFim, setDataFim] = useState(
    agora.getFullYear() +
      "-" +
      agora.getMonth() +
      "-" +
      agora.getDate() +
      "23:59"
  );
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [idCartao, setIdCartao] = useState("");
  const [grupoIngresso, setGrupoIngresso] = useState("");
  const [turnoInicial, setTurnoInicial] = useState("");
  const [turnoFinal, setTurnoFinal] = useState("");
  const [codigoPDV, setCodigoPDV] = useState("");

  async function selecionarReport(option) {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Cardapio`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
        },
      })
      .then((retorno) => {
        let cardapioOptions = [{ label: "", value: "" }];
        retorno.data.map((item) => {
          let option = {
            label: item.CODIGO + " - " + item.DESCRICAO,
            value: item.CODIGO,
          };
          cardapioOptions.push(option);
        });
        setMenuOptions(cardapioOptions);
        setSelectedReport(option);
      });
  }

  // HANDLER async functionS
  async function handleSubmit(e) {
    e.preventDefault();

    setIsLoading(true);
    setShowReportData(true);

    switch (selectedReport) {
      case "fechamento":
        processFechamento();
        break;
      case "vendasPeriodo":
        processVendasPeriodo();
        break;
      case "vendasTurno":
        processVendasTurno();
        break;
      case "vendasCardapio":
        processVendasCardapio();
        break;
      case "consumoCartao":
        processConsumoCartao();
        break;
      case "vendasPagamento":
        processVendasPagamento();
        break;
      case "vendasIngresso":
        processIngresso();
        break;
      case "retiradaReforco":
        processRetiradaReforco();
        break;
      default:
        console.warn("No matching report type found." + selectedReport);
        setIsLoading(false);
        setShowReportData(false);
        break;
    }
  }

  async function processFechamento() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/fechamento`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          turnoInicial: turnoInicial || 0,
          turnoFinal: turnoFinal || 9999,
          codpdv: codigoPDV,
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          let totalProdutos = 0;
          let totalPagamentos = 0;

          retorno.data = retorno.data.map((pdv) => {
            pdv?.produtos.map((produto) => {
              totalProdutos += produto.TOTAL;
            });
            pdv?.pagamentos.map((pagamento) => {
              totalPagamentos += pagamento.VALORPGTO;
            });

            pdv.totalProdutos = totalProdutos;
            pdv.totalPagamentos = totalPagamentos;
            totalPagamentos = 0;
            totalProdutos = 0;
            return pdv;
          });
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }

  async function processIngresso() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/InfoIngresso`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          grupoIngresso: grupoIngresso,
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }
  async function processVendasPeriodo() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/VendasPeriodo`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          datainicial: formatDateTimeLocal(dataInicial),
          datafinal: formatDateTimeLocal(dataFim),
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }

  async function processVendasTurno() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/vendasTurnoPDV`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          datainicial: formatDateTimeLocal(dataInicial),
          datafinal: formatDateTimeLocal(dataFim),
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }

  async function processVendasCardapio() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/VendasCardapio`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          datainicial: formatDateTimeLocal(dataInicial),
          datafinal: formatDateTimeLocal(dataFim),
          codcardapio: selectedMenu ?? null,
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }

  async function processVendasPagamento() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/VendasFormaPgto`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          datainicial: formatDateTimeLocal(dataInicial),
          datafinal: formatDateTimeLocal(dataFim),
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }

  async function processConsumoCartao() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/Cartao`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          idcartao: idCartao,
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }

  async function processRetiradaReforco() {
    axios
      .get(`${process.env.REACT_APP_API_URL}/relatorioRetRef`, {
        headers: { auth: process.env.REACT_APP_API_TOKEN },
        params: {
          codaluguel: codigoEvento(),
          turnoInicial: turnoInicial || 0,
          turnoFinal: turnoFinal || 9999,
        },
      })
      .then((retorno) => {
        if (retorno.status === 200) {
          setReportData(retorno.data);
          setIsLoading(false);
          setError(false);
        } else {
          setIsLoading(false);
          setError(true);
          setReportData(null);
          setShowReportData(false);
        }
      });
  }

  const filtrados = menuOptions.filter((opt) =>
    opt.label.toLowerCase().includes(busca.toLowerCase())
  );

  const handleSelecionar = (option) => {
    setBusca(option.label);
    setAberto(false);
    setSelectedMenu(option.value);
  };

  const reportComponents = {
    fechamento: () => <Fechamento reportData={reportData} />,
    vendasPeriodo: () => <VendasPeriodo reportData={reportData} />,
    vendasTurno: () => <VendasTurnoPDV reportData={reportData} />,
    vendasCardapio: () => (
      <VendasCardapio
        reportData={reportData}
        cardapios={menuOptions}
        selectedMenu={selectedMenu}
      />
    ),
    consumoCartao: () => <ConsumoCartao reportData={reportData} />,
    vendasPagamento: () => <VendasPagamento reportData={reportData} />,
    vendasIngresso: () => <VendasIngressos reportData={reportData} />,
    retiradaReforco: () => <RetiradaReforco reportData={reportData} />,
  };

  const pdfComponents = {
    fechamento: () => <FechamentoPDF data={reportData} />,
    vendasPeriodo: () => (
      <VendasPeriodoPDF
        data={reportData}
        dataInicial={dataInicial}
        dataFinal={dataFim}
        total={reportData.reduce(
          (acc, produto) => {
            acc.total += produto.TOTAL ?? 0;
            acc.qtde += produto.QTDE ?? 0;
            acc.comissao += produto.COMISSAO ?? 0;
            return acc;
          },
          { total: 0, qtde: 0, comissao: 0 }
        )}
      />
    ),
    vendasTurno: () => (
      <VendasTurnoPDF
        data={reportData}
        dataInicial={dataInicial}
        dataFinal={dataFim}
      />
    ),
    vendasCardapio: () => (
      <VendasCardapioPDF
        data={reportData}
        dataInicial={dataInicial}
        dataFinal={dataFim}
        cardapios={menuOptions}
        selectedMenu={selectedMenu}
      />
    ),
    consumoCartao: () => (
      <ConsumoCartaoPDF
        data={reportData}
        codigoCartao={idCartao}
        totalCredito={reportData[0]?.credito?.reduce(
          (acc, item) => acc + Number(item.TOTAL),
          0
        )}
        totalDebito={reportData[0]?.debito?.reduce(
          (acc, item) => acc + Number(item.TOTAL),
          0
        )}
      />
    ),
    vendasPagamento: () => (
      <VendasPagamentoPDF
        data={reportData}
        dataInicial={dataInicial}
        dataFinal={dataFim}
      />
    ),
    retiradaReforco: () => (
      <RetiradaReforcoPDF
        data={reportData}
        dataInicial={dataInicial}
        dataFinal={dataFim}
      />
    ),
    vendasIngresso: () => (
      <VendasIngressosPDF data={reportData} grupoIngresso={grupoIngresso} />
    ),
  };

  const xlsComponents = {
    fechamento: () => exportarFechamentoParaExcel(reportData),
    consumoCartao: () =>
      exportarConsumoCartaoParaExcel({
        data: reportData,
        codigoCartao: idCartao,
        totalCredito: reportData[0]?.credito?.reduce(
          (acc, item) => acc + Number(item.TOTAL),
          0
        ),
        totalDebito: reportData[0]?.debito?.reduce(
          (acc, item) => acc + Number(item.TOTAL),
          0
        ),
      }),
    vendasCardapio: () =>
      exportarVendasCardapioParaExcel({
        data: reportData,
        dataInicial: dataInicial,
        dataFinal: dataFim,
        cardapios: menuOptions,
        selectedMenu: selectedMenu,
      }),
    vendasPagamento: () =>
      exportarVendasPagamentoParaExcel({
        data: reportData,
        dataInicial: dataInicial,
        dataFinal: dataFim,
      }),
    vendasPeriodo: () =>
      exportarVendasPeriodoParaExcel({
        data: reportData,
        dataInicial: dataInicial,
        dataFinal: dataFim,
      }),
    vendasTurno: () =>
      exportarVendasTurnoParaExcel({
        data: reportData,
        dataInicial: dataInicial,
        dataFinal: dataFim,
      }),
    retiradaReforco: () =>
      exportarRetiradaReforcoParaExcel({
        data: reportData,
      }),
    vendasIngresso: () =>
      exportarVendasIngressosParaExcel({
        data: reportData,
        grupoIngresso: grupoIngresso,
      }),
  };

  async function handleExportPDF() {
    const blob = await pdf(pdfComponents[selectedReport]()).toBlob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  async function exportarFechamentoParaExcel(data) {
    const sheetData = [];
    const merges = [];

    data.forEach((item, index) => {
      if (index > 0) sheetData.push([]);

      // Título PDV (negrito + tamanho maior + merge de colunas)
      const titleRowIndex = sheetData.length;
      sheetData.push([
        {
          v: `PDV: ${item.CODPDV}`,
          s: {
            font: { bold: true, sz: 14 },
            alignment: { horizontal: "center" },
          },
        },
      ]);
      merges.push({
        s: { r: titleRowIndex, c: 0 },
        e: { r: titleRowIndex, c: 3 },
      });

      // Info básica
      sheetData.push([
        `Turno: ${item.TURNO}`,
        `Responsável: ${item.RESPONSAVEL}`,
        `Abertura: ${new Date(item.DATAABERTURATURNO).toLocaleString("pt-BR")}`,
        `Fechamento: ${new Date(item.DATAFECHATURNO).toLocaleString("pt-BR")}`,
      ]);
      sheetData.push([]);

      // Produtos Vendidos
      sheetData.push([
        {
          v: "Produtos Vendidos",
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        },
      ]);
      sheetData.push([
        { v: "Produto", s: { font: { bold: true } } },
        { v: "Quantidade", s: { font: { bold: true } } },
        {
          v: "Total",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
      ]);
      item.produtos.forEach((produto) => {
        sheetData.push([
          produto.DESCRICAO,
          produto.QTDE,
          {
            v: produto.TOTAL,
            t: "n",
            s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
          },
        ]);
      });
      sheetData.push([
        { v: "Total", s: { font: { bold: true } } },
        "",
        {
          v: item.totalProdutos,
          t: "n",
          s: {
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "R$ #,##0.00",
          },
        },
      ]);
      sheetData.push([]);

      // Pagamentos
      sheetData.push([
        {
          v: "Pagamentos",
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        },
      ]);
      sheetData.push([
        { v: "Forma de Pagamento", s: { font: { bold: true } } },
        {
          v: "Total",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
      ]);
      item.pagamentos.forEach((pagamento) => {
        sheetData.push([
          pagamento.DESCRICAOPGTO,
          {
            v: pagamento.VALORPGTO,
            t: "n",
            s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
          },
        ]);
      });
      sheetData.push([
        { v: "Total", s: { font: { bold: true } } },
        {
          v: item.totalPagamentos,
          t: "n",
          s: {
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "R$ #,##0.00",
          },
        },
      ]);
      sheetData.push([]);

      // Totais
      sheetData.push([
        {
          v: "Totais",
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        },
      ]);
      sheetData.push([
        { v: "Descrição", s: { font: { bold: true } } },
        {
          v: "Valor",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
      ]);
      sheetData.push([
        "Saldo Inicial",
        {
          v: item.TROCOABERTURA,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
      ]);
      sheetData.push([
        "Produtos Vendidos",
        {
          v: item.totalProdutos,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
      ]);
      sheetData.push(["Retirada", ""]);
      sheetData.push(["Reforço", ""]);
      sheetData.push([
        "Total",
        {
          v: item.totalPagamentos,
          t: "n",
          s: {
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "R$ #,##0.00",
          },
        },
      ]);
    });

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!merges"] = merges;

    // Ajuste opcional: largura de colunas
    ws["!cols"] = [{ wch: 30 }, { wch: 25 }, { wch: 20 }, { wch: 25 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Relatório Fechamento");
    XLSX.writeFile(wb, "relatorio_fechamento.xlsx");
  }

  async function exportarConsumoCartaoParaExcel({
    data,
    codigoCartao,
    totalCredito,
    totalDebito,
  }) {
    const sheetData = [];

    const saldoTotal = totalCredito - totalDebito;
    const saldoDesbloqueado =
      saldoTotal - data[0]?.VALORCARTAO - saldoTotal * data[0]?.SALDORES * 0.01;

    // Título principal
    sheetData.push([
      {
        v: `Consumo por Cartão - ${codigoCartao}`,
        s: {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" },
        },
      },
    ]);
    sheetData.push([]);
    sheetData.push([
      "Valor do Cartão",
      {
        v: data[0]?.VALORCARTAO,
        t: "n",
        s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
      },
    ]);
    sheetData.push([
      "Saldo Residual (%)",
      {
        v: data[0]?.SALDORES / 100,
        t: "n",
        s: { alignment: { horizontal: "right" }, numFmt: "0.00%" },
      },
    ]);
    sheetData.push([]);

    // Créditos
    sheetData.push([
      {
        v: "Créditos",
        s: { font: { bold: true }, alignment: { horizontal: "left" } },
      },
    ]);
    sheetData.push([
      { v: "Data/Hora", s: { font: { bold: true } } },
      { v: "PDV", s: { font: { bold: true } } },
      { v: "Turno/Operador", s: { font: { bold: true } } },
      { v: "Produto", s: { font: { bold: true } } },
      {
        v: "Valor Unitário",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: "Quantidade",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: "Total",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
    ]);

    data[0]?.credito?.forEach((row) => {
      sheetData.push([
        new Date(row.DATAHORA).toLocaleString("pt-BR"),
        row.PDV,
        `${row.TURNO} - ${row.RESPONSAVEL}`,
        `${row.CODPROD} - ${row.DESCPROD}`,
        {
          v: row.VALORUNI,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
        { v: row.QTDE, t: "n", s: { alignment: { horizontal: "right" } } },
        {
          v: row.TOTAL,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
      ]);
    });

    sheetData.push([
      "",
      "",
      "",
      "",
      "",
      {
        v: "Total de Créditos",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: totalCredito,
        t: "n",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
          numFmt: "R$ #,##0.00",
        },
      },
    ]);
    sheetData.push([]);

    // Débitos
    sheetData.push([
      {
        v: "Débitos",
        s: { font: { bold: true }, alignment: { horizontal: "left" } },
      },
    ]);
    sheetData.push([
      { v: "Data/Hora", s: { font: { bold: true } } },
      { v: "PDV", s: { font: { bold: true } } },
      { v: "Turno/Operador", s: { font: { bold: true } } },
      { v: "Produto", s: { font: { bold: true } } },
      {
        v: "Valor Unitário",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: "Quantidade",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: "Total",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
    ]);

    data[0]?.debito?.forEach((row) => {
      sheetData.push([
        new Date(row.DATAHORA).toLocaleString("pt-BR"),
        row.PDV,
        `${row.TURNO} - ${row.RESPONSAVEL}`,
        `${row.CODPROD} - ${row.DESCPROD}`,
        {
          v: row.VALORUNI,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
        { v: row.QTDE, t: "n", s: { alignment: { horizontal: "right" } } },
        {
          v: row.TOTAL,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
      ]);
    });

    sheetData.push([
      "",
      "",
      "",
      "",
      "",
      {
        v: "Total de Débitos",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: totalDebito,
        t: "n",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
          numFmt: "R$ #,##0.00",
        },
      },
    ]);
    sheetData.push([]);

    // Saldo final
    sheetData.push([
      {
        v: "Resumo",
        s: { font: { bold: true }, alignment: { horizontal: "left" } },
      },
    ]);
    sheetData.push([
      "Saldo Total",
      {
        v: saldoTotal,
        t: "n",
        s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
      },
    ]);
    sheetData.push([
      "Saldo Desbloqueado",
      {
        v: saldoDesbloqueado,
        t: "n",
        s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
      },
    ]);

    // Montagem do workbook
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!cols"] = [
      { wch: 20 },
      { wch: 10 },
      { wch: 20 },
      { wch: 30 },
      { wch: 15 },
      { wch: 10 },
      { wch: 15 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, `ConsumoCartao_${codigoCartao}`);
    XLSX.writeFile(wb, `consumo_cartao_${codigoCartao}.xlsx`);
  }

  async function exportarVendasCardapioParaExcel({
    data,
    dataInicial,
    dataFinal,
    cardapios,
    selectedMenu,
  }) {
    const sheetData = [];

    const cardapioSelecionado = cardapios.find(
      (cardapio) => cardapio.value === selectedMenu
    );

    const nomeCardapio = cardapioSelecionado
      ? cardapioSelecionado.label
      : "Sem Cardápio";

    // Título principal
    sheetData.push([
      {
        v: "Vendas por Cardápio",
        s: {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" },
        },
      },
    ]);
    sheetData.push([
      `Período: ${new Date(dataInicial).toLocaleString("pt-BR")} até ${new Date(
        dataFinal
      ).toLocaleString("pt-BR")}`,
    ]);
    sheetData.push([]);

    // Para cada seção de dados (geralmente 1 cardápio, mas já preparado para vários)
    data.forEach((item) => {
      sheetData.push([
        {
          v: nomeCardapio,
          s: {
            font: { bold: true, sz: 12 },
            alignment: { horizontal: "left" },
          },
        },
      ]);

      sheetData.push([
        { v: "Produto", s: { font: { bold: true } } },
        {
          v: "Quantidade",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
        {
          v: "Comissão",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
        {
          v: "Total",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
      ]);

      item.vendas.forEach((row) => {
        sheetData.push([
          `${row.CODIGO} - ${row.DESCRICAO}`,
          { v: row.QTDE, t: "n", s: { alignment: { horizontal: "right" } } },
          {
            v: row.COMISSAO,
            t: "n",
            s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
          },
          {
            v: row.TOTAL,
            t: "n",
            s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
          },
        ]);
      });

      sheetData.push([
        { v: "Total", s: { font: { bold: true } } },
        {
          v: item.totais.qtde,
          t: "n",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
        {
          v: item.totais.comissao,
          t: "n",
          s: {
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "R$ #,##0.00",
          },
        },
        {
          v: item.totais.total,
          t: "n",
          s: {
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "R$ #,##0.00",
          },
        },
      ]);

      sheetData.push([]); // Linha vazia para separar cardápios (caso venha mais de um no futuro)
    });

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!cols"] = [{ wch: 35 }, { wch: 12 }, { wch: 15 }, { wch: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "VendasCardapio");

    XLSX.writeFile(wb, "relatorio_vendas_cardapio.xlsx");
  }

  async function exportarVendasPagamentoParaExcel({
    data,
    dataInicial,
    dataFinal,
  }) {
    const sheetData = [];

    // Calcula totais (igual ao PDF)
    const total = data.reduce(
      (acc, produto) => {
        acc.total += produto.TOTAL ?? 0;
        acc.qtde += produto.QTDE ?? 0;
        return acc;
      },
      { total: 0, qtde: 0 }
    );

    // Título principal
    sheetData.push([
      {
        v: "Vendas por Forma de Pagamento",
        s: {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" },
        },
      },
    ]);
    sheetData.push([
      `Período: ${new Date(dataInicial).toLocaleString("pt-BR")} até ${new Date(
        dataFinal
      ).toLocaleString("pt-BR")}`,
    ]);
    sheetData.push([]);

    // Cabeçalho da tabela
    sheetData.push([
      { v: "Forma de Pagamento", s: { font: { bold: true } } },
      {
        v: "Quantidade",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: "Total",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
    ]);

    // Dados da tabela
    data.forEach((item) => {
      sheetData.push([
        `${item.CODFORMAPGTO} - ${item.DESCFORMAPGTO}`,
        { v: item.QTDE, t: "n", s: { alignment: { horizontal: "right" } } },
        {
          v: item.TOTAL,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
      ]);
    });

    // Linha de totais
    sheetData.push([
      { v: "Total", s: { font: { bold: true } } },
      {
        v: total.qtde,
        t: "n",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: total.total,
        t: "n",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
          numFmt: "R$ #,##0.00",
        },
      },
    ]);

    // Criação da planilha
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!cols"] = [{ wch: 40 }, { wch: 15 }, { wch: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "VendasPagamento");

    XLSX.writeFile(wb, "relatorio_vendas_pagamento.xlsx");
  }

  async function exportarVendasPeriodoParaExcel({
    data,
    dataInicial,
    dataFinal,
  }) {
    const sheetData = [];

    // Calcula total igual no PDF
    const total = data.reduce(
      (acc, item) => {
        acc.qtde += item.QTDE ?? 0;
        acc.comissao += item.COMISSAO ?? 0;
        acc.total += item.TOTAL ?? 0;
        return acc;
      },
      { qtde: 0, comissao: 0, total: 0 }
    );

    // Título principal
    sheetData.push([
      {
        v: "Vendas por Período",
        s: {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" },
        },
      },
    ]);
    sheetData.push([
      `Período: ${new Date(dataInicial).toLocaleString("pt-BR")} até ${new Date(
        dataFinal
      ).toLocaleString("pt-BR")}`,
    ]);
    sheetData.push([]);

    // Cabeçalho da tabela
    sheetData.push([
      { v: "Produto", s: { font: { bold: true } } },
      {
        v: "Quantidade",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: "Comissão",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: "Total",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
    ]);

    // Dados dos produtos vendidos
    data.forEach((row) => {
      sheetData.push([
        `${row.CODPROD} - ${row.DESCRICAO}`,
        { v: row.QTDE, t: "n", s: { alignment: { horizontal: "right" } } },
        {
          v: row.COMISSAO ? row.COMISSAO : 0,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
        {
          v: row.TOTAL,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
      ]);
    });

    // Linha dos totais
    sheetData.push([
      { v: "Total", s: { font: { bold: true } } },
      {
        v: total.qtde,
        t: "n",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: total.comissao,
        t: "n",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
          numFmt: "R$ #,##0.00",
        },
      },
      {
        v: total.total,
        t: "n",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
          numFmt: "R$ #,##0.00",
        },
      },
    ]);

    // Criação da planilha
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!cols"] = [{ wch: 35 }, { wch: 12 }, { wch: 15 }, { wch: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "VendasPeriodo");

    XLSX.writeFile(wb, "relatorio_vendas_periodo.xlsx");
  }

  async function exportarVendasTurnoParaExcel({
    data,
    dataInicial,
    dataFinal,
  }) {
    const sheetData = [];
    const merges = [];

    // Título principal
    const titleRowIndex = sheetData.length;
    sheetData.push([
      {
        v: "Vendas por Turno e PDV",
        s: {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" },
        },
      },
      null,
      null,
      null,
    ]);
    merges.push({
      s: { r: titleRowIndex, c: 0 },
      e: { r: titleRowIndex, c: 3 },
    });

    // Período
    sheetData.push([
      `Período: ${new Date(dataInicial).toLocaleString("pt-BR")} até ${new Date(
        dataFinal
      ).toLocaleString("pt-BR")}`,
      null,
      null,
      null,
    ]);
    merges.push({
      s: { r: titleRowIndex + 1, c: 0 },
      e: { r: titleRowIndex + 1, c: 3 },
    });

    sheetData.push([]);

    data.forEach((item, index) => {
      // Informações do PDV
      const pdvRowIndex = sheetData.length;
      sheetData.push([
        {
          v: `PDV: ${item?.CODPDV ?? "N/A"}`,
          s: {
            font: { bold: true, sz: 12 },
            alignment: { horizontal: "left" },
          },
        },
        null,
        null,
        null,
      ]);
      merges.push({ s: { r: pdvRowIndex, c: 0 }, e: { r: pdvRowIndex, c: 3 } });

      sheetData.push([
        `Turno: ${item?.TURNO ?? ""} | Responsável: ${
          item?.RESPONSAVEL ?? ""
        } | Abertura: ${
          item?.ABERTURA
            ? new Date(item.ABERTURA).toLocaleString("pt-BR")
            : "N/A"
        } | Fechamento: ${
          item?.FECHAMENTO
            ? new Date(item.FECHAMENTO).toLocaleString("pt-BR")
            : "N/A"
        }`,
        null,
        null,
        null,
      ]);
      merges.push({
        s: { r: pdvRowIndex + 1, c: 0 },
        e: { r: pdvRowIndex + 1, c: 3 },
      });

      sheetData.push([]);

      // Cabeçalho da tabela
      sheetData.push([
        { v: "Produto", s: { font: { bold: true } } },
        {
          v: "Quantidade",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
        {
          v: "Comissão",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
        {
          v: "Total",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
      ]);

      // Vendas do turno
      item?.vendas?.forEach((row) => {
        sheetData.push([
          `${row?.CODPROD ?? ""} - ${row?.DESCRICAO ?? ""}`,
          {
            v: row?.QTDE ?? 0,
            t: "n",
            s: { alignment: { horizontal: "right" } },
          },
          {
            v: row?.COMISSAO ?? 0,
            t: "n",
            s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
          },
          {
            v: row?.TOTAL ?? 0,
            t: "n",
            s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
          },
        ]);
      });

      // Totais do turno
      sheetData.push([
        { v: "Total", s: { font: { bold: true } } },
        {
          v: item?.totais?.qtde ?? 0,
          t: "n",
          s: { font: { bold: true }, alignment: { horizontal: "right" } },
        },
        {
          v: item?.totais?.comissao ?? 0,
          t: "n",
          s: {
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "R$ #,##0.00",
          },
        },
        {
          v: item?.totais?.total ?? 0,
          t: "n",
          s: {
            font: { bold: true },
            alignment: { horizontal: "right" },
            numFmt: "R$ #,##0.00",
          },
        },
      ]);

      sheetData.push([]); // Espaço entre turnos
    });

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!merges"] = merges;
    ws["!cols"] = [{ wch: 35 }, { wch: 12 }, { wch: 15 }, { wch: 20 }];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "VendasTurno");

    XLSX.writeFile(wb, "relatorio_vendas_turno.xlsx");
  }

  async function exportarRetiradaReforcoParaExcel({ data }) {
    const sheetData = [];
    const merges = [];

    // Cálculo de totais
    const totalRetirada = data
      .filter((row) => row.TIPO === "R")
      .reduce((sum, row) => sum + (row.VALOR ?? 0), 0);

    const totalReforco = data
      .filter((row) => row.TIPO !== "R")
      .reduce((sum, row) => sum + (row.VALOR ?? 0), 0);

    // Título
    const titleRowIndex = sheetData.length;
    sheetData.push([
      {
        v: "Retirada e Reforço",
        s: {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" },
        },
      },
      null,
      null,
      null,
      null,
      null,
    ]);
    merges.push({
      s: { r: titleRowIndex, c: 0 },
      e: { r: titleRowIndex, c: 5 },
    });

    sheetData.push([
      `Emitido em: ${new Date().toLocaleString("pt-BR")}`,
      null,
      null,
      null,
      null,
      null,
    ]);
    merges.push({
      s: { r: titleRowIndex + 1, c: 0 },
      e: { r: titleRowIndex + 1, c: 5 },
    });

    sheetData.push([]);

    // Cabeçalho
    sheetData.push([
      { v: "Data/Hora", s: { font: { bold: true } } },
      { v: "Descrição", s: { font: { bold: true } } },
      { v: "Tipo", s: { font: { bold: true } } },
      { v: "PDV", s: { font: { bold: true } } },
      { v: "Turno", s: { font: { bold: true } } },
      {
        v: "Valor",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
    ]);

    // Dados
    data.forEach((row) => {
      sheetData.push([
        row?.DATAHORA ? new Date(row.DATAHORA).toLocaleString("pt-BR") : "",
        row?.DESCRICAO ?? "",
        row?.TIPO === "R" ? "Retirada" : "Reforço",
        row?.CODPDV ?? "",
        row?.TURNO ?? "",
        {
          v: row?.VALOR ?? 0,
          t: "n",
          s: { alignment: { horizontal: "right" }, numFmt: "R$ #,##0.00" },
        },
      ]);
    });

    // Totais
    sheetData.push([]);
    sheetData.push([
      "",
      "",
      "",
      "",
      {
        v: "Total Retirada:",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: totalRetirada,
        t: "n",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
          numFmt: "R$ #,##0.00",
        },
      },
    ]);

    sheetData.push([
      "",
      "",
      "",
      "",
      {
        v: "Total Reforço:",
        s: { font: { bold: true }, alignment: { horizontal: "right" } },
      },
      {
        v: totalReforco,
        t: "n",
        s: {
          font: { bold: true },
          alignment: { horizontal: "right" },
          numFmt: "R$ #,##0.00",
        },
      },
    ]);

    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!merges"] = merges;
    ws["!cols"] = [
      { wch: 20 },
      { wch: 25 },
      { wch: 12 },
      { wch: 10 },
      { wch: 10 },
      { wch: 15 },
    ];

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "RetiradaReforco");

    XLSX.writeFile(wb, "relatorio_retirada_reforco.xlsx");
  }

  async function exportarVendasIngressosParaExcel({ data, grupoIngresso }) {
    const sheetData = [];
    const merges = [];

    // Título
    const titleRowIndex = sheetData.length;
    sheetData.push([
      {
        v: `Vendas Ingressos - Grupo ${grupoIngresso}`,
        s: {
          font: { bold: true, sz: 14 },
          alignment: { horizontal: "center" },
        },
      },
      null,
      null,
      null,
      null,
      null,
      null,
    ]);
    merges.push({
      s: { r: titleRowIndex, c: 0 },
      e: { r: titleRowIndex, c: 6 },
    });

    // Subtítulo com data de emissão
    sheetData.push([
      {
        v: `Emitido em ${new Date().toLocaleDateString("pt-BR", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        })}`,
        s: {
          alignment: { horizontal: "center" },
        },
      },
      null,
      null,
      null,
      null,
      null,
      null,
    ]);
    merges.push({
      s: { r: titleRowIndex + 1, c: 0 },
      e: { r: titleRowIndex + 1, c: 6 },
    });

    // Linha em branco para separação
    sheetData.push([]);

    // Cabeçalho da tabela
    sheetData.push([
      { v: "Grupo", s: { font: { bold: true } } },
      { v: "Código SC", s: { font: { bold: true } } },
      { v: "QR Code", s: { font: { bold: true } } },
      { v: "Data/Hora de Emissão", s: { font: { bold: true } } },
      { v: "Operador", s: { font: { bold: true } } },
      { v: "PDV", s: { font: { bold: true } } },
      { v: "Forma de Pagamento", s: { font: { bold: true } } },
    ]);

    // Dados das linhas
    data.forEach((row) => {
      sheetData.push([
        row?.GRUPOINGRESSO ?? "",
        row?.CODINGRESSO ?? "",
        row?.QRCODE ?? "",
        row?.DATAHORA
          ? new Intl.DateTimeFormat("pt-BR", {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            }).format(new Date(row.DATAHORA))
          : "",
        row?.RESPONSAVEL ?? "",
        row?.CODPDV ?? "",
        row?.FORMASPAGAMENTO?.[0]?.FORMAPGTO ?? "",
      ]);
    });

    // Crie a planilha
    const ws = XLSX.utils.aoa_to_sheet(sheetData);
    ws["!merges"] = merges;

    // Defina as larguras das colunas (similares às proporções do PDF)
    ws["!cols"] = [
      { wch: 15 }, // Grupo (20%)
      { wch: 15 }, // Código SC (20%)
      { wch: 10 }, // QR Code (10%)
      { wch: 20 }, // Data/Hora (20%)
      { wch: 12 }, // Operador (10%)
      { wch: 8 }, // PDV (10%)
      { wch: 18 }, // Forma de Pagamento (10%)
    ];

    // Crie o workbook e adicione a planilha
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Vendas Ingressos");

    // Salve o arquivo
    XLSX.writeFile(wb, "relatorio_vendas_ingressos.xlsx");
  }

  return (
    <Layout>
      <div className="font-Roboto p-4 box-border flex flex-col gap-4 justify-center items-center w-full">
        {!selectedReport ? (
          <>
            <h1>Selecionar Relatório</h1>
            <div className="flex gap-4 flex-wrap justify-center items-center w-full lg:w-1/2">
              <button
                onClick={() => {
                  selecionarReport("vendasPeriodo");
                  setReportName("Vendas por Período");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <FaRegCalendarAlt className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Vendas por Período
                </div>
              </button>

              <button
                onClick={() => {
                  selecionarReport("vendasTurno");
                  setReportName("Vendas por Turno e PDV");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <FaRegClock className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Vendas por Turno e PDV
                </div>
              </button>

              <button
                onClick={() => {
                  selecionarReport("vendasCardapio");
                  setReportName("Vendas por Cardápio");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <PiNotebookBold className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Vendas por Cardápio
                </div>
              </button>

              <button
                onClick={() => {
                  selecionarReport("consumoCartao");
                  setReportName("Consumo por Cartão");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <FaCreditCard className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Consumo por Cartão
                </div>
              </button>

              <button
                onClick={() => {
                  selecionarReport("vendasPagamento");
                  setReportName("Vendas por Forma de Pagamento");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <AiOutlineDollar className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Vendas por Forma de Pagamento
                </div>
              </button>

              <button
                onClick={() => {
                  selecionarReport("vendasIngresso");
                  setReportName("Vendas de Ingressos");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <PiTicketBold className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Vendas de Ingressos
                </div>
              </button>

              <button
                onClick={() => {
                  selecionarReport("retiradaReforco");
                  setReportName("Retirada e Reforço");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <PiHandWithdrawBold className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Retirada e Reforço
                </div>
              </button>

              <button
                onClick={() => {
                  selecionarReport("fechamento");
                  setReportName("Fechamento");
                }}
                className="font-Roboto flex p-2 flex-col items-center justify-center gap-2 w-44 h-44 border border-gray-400 bg-white rounded-lg shadow-md hover:bg-[#ccc] transition cursor-pointer text-center"
              >
                <div className="w-10 h-10 flex items-center justify-center">
                  <RiDoorClosedLine className="w-8 h-8" />
                </div>
                <div className="text-lg h-12 text-wrap font-[500] text-center leading-snug">
                  Fechamento
                </div>
              </button>
            </div>
          </>
        ) : selectedReport ? (
          <div className="font-Roboto flex flex-col rounded-lg gap-4 p-4 w-full justify-center items-center">
            <h1 className="text-center font-Oswald">{reportName}</h1>

            <form
              onSubmit={(event) => handleSubmit(event)}
              className="flex flex-col flex-wrap gap-12 w-full justify-center items-center"
            >
              {error ? (
                <div className="flex rounded-lg bg-[#ff9853] border border-solid border-[#fc7e2a] flex-col gap-4 justify-center items-center p-4 w-fit">
                  <h4>
                    Oops! Um erro ocorreu ao tentar carregar os dados do
                    relatório.
                  </h4>
                  <p>Verifique o conteúdo digitado e tente novamente.</p>
                </div>
              ) : null}

              <div className="flex gap-4 lg:gap-12 flex-wrap justify-center items-center">
                <button
                  type="button"
                  onClick={() => {
                    selecionarReport(null);
                    setReportName("");
                    setShowReportData(false);
                    setReportData(null);
                  }}
                  className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#E60000] text-white transition cursor-pointer hover:bg-[#bd1919] font-Roboto"
                >
                  <FaLongArrowAltLeft size={20} />

                  <span>Voltar</span>
                </button>

                {selectedReport === "vendasPeriodo" ||
                selectedReport === "vendasTurno" ||
                selectedReport === "vendasCardapio" ||
                selectedReport === "vendasPagamento" ? (
                  <>
                    {selectedReport === "vendasCardapio" ? (
                      <div className="font-Roboto flex flex-col gap-2 w-fit">
                        <label
                          className="font-Roboto text-base font-[500] w-fit"
                          htmlFor="select"
                        >
                          Cardápio
                        </label>
                        <div className="font-Roboto font-[500] relative">
                          <input
                            autocomplete="off"
                            type="text"
                            name="select"
                            className="font-Roboto w-fit text-base font-[500] border border-solid border-gray-400 rounded-md p-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Selecione uma opção"
                            value={busca}
                            onChange={(e) => {
                              setBusca(e.target.value);
                              setAberto(!aberto);
                            }}
                            onFocus={() => {
                              setBusca("");
                              setAberto(!aberto);
                            }}
                          />

                          {aberto && (
                            <ul className="font-Roboto text-base font-[500] absolute z-10 w-full bg-white border border-gray-300 rounded-md max-h-60 overflow-y-auto shadow-md">
                              {filtrados.length > 0 ? (
                                filtrados.map((option) => (
                                  <li
                                    key={option.value}
                                    className="px-4 py-2 cursor-pointer hover:bg-blue-100"
                                    onClick={() => handleSelecionar(option)}
                                  >
                                    {option.label}
                                  </li>
                                ))
                              ) : (
                                <li className="font-Roboto px-4 py-2 text-gray-500">
                                  Nenhuma opção encontrada
                                </li>
                              )}
                            </ul>
                          )}
                        </div>
                      </div>
                    ) : null}
                    <div className="font-Roboto flex flex-col gap-2">
                      <label
                        className="text-base font-[500]"
                        htmlFor="dataInicial"
                      >
                        Data de Início
                      </label>
                      <input
                        onChange={(e) => {
                          console.log(e.target.value);
                          setdataInicial(e.target.value);
                        }}
                        className="font-Roboto border border-solid border-gray-400 text-base rounded-lg p-2"
                        name="dataInicial"
                        type="datetime-local"
                        value={dataInicial}
                        required
                      />
                    </div>

                    <div className="font-Roboto flex flex-col gap-2">
                      <label className="text-base font-[500]" htmlFor="dataFim">
                        Data de Fim
                      </label>
                      <input
                        onChange={(e) => setDataFim(e.target.value)}
                        className="font-Roboto border border-solid border-gray-400 text-base rounded-lg p-2"
                        name="dataFim"
                        type="datetime-local"
                        value={dataFim}
                        required
                      />
                    </div>
                  </>
                ) : selectedReport === "consumoCartao" ? (
                  <>
                    <div className="font-Roboto flex flex-col gap-2">
                      <label
                        className="text-base font-[500]"
                        htmlFor="idCartao"
                      >
                        ID do Cartão
                      </label>
                      <input
                        onChange={(e) => setIdCartao(e.target.value)}
                        className="font-Roboto border border-solid border-gray-400 text-base rounded-lg p-2"
                        name="idCartao"
                        type="text"
                        required
                      />
                    </div>
                  </>
                ) : selectedReport === "vendasIngresso" ? (
                  <>
                    <div className="font-Roboto flex flex-col gap-2">
                      <label
                        className="text-base font-[500]"
                        htmlFor="grupoIngresso"
                      >
                        Grupo do Ingresso
                      </label>
                      <input
                        onChange={(e) => setGrupoIngresso(e.target.value)}
                        className="font-Roboto border border-solid border-gray-400 text-base rounded-lg p-2"
                        name="grupoIngresso"
                        type="text"
                      />
                    </div>
                  </>
                ) : selectedReport === "retiradaReforco" ||
                  selectedReport === "fechamento" ? (
                  <>
                    <div className="font-Roboto flex flex-col gap-2">
                      <label
                        className="text-base font-[500]"
                        htmlFor="turnoInicial"
                      >
                        Turno inicial
                      </label>
                      <input
                        onChange={(e) => setTurnoInicial(e.target.value)}
                        className="font-Roboto border border-solid border-gray-400 text-base rounded-lg p-2"
                        name="turnoInicial"
                        type="number"
                        min={0}
                      />
                    </div>

                    <div className="font-Roboto flex flex-col gap-2">
                      <label
                        className="text-base font-[500]"
                        htmlFor="turnoFinal"
                      >
                        Turno Final
                      </label>
                      <input
                        onChange={(e) => setTurnoFinal(e.target.value)}
                        className="font-Roboto border border-solid border-gray-400 text-base rounded-lg p-2"
                        name="turnoFinal"
                        type="number"
                        min={0}
                      />
                    </div>

                    <div className="font-Roboto flex flex-col gap-2">
                      <label
                        className="text-base font-[500]"
                        htmlFor="codigoPDV"
                      >
                        Código PDV
                      </label>
                      <input
                        onChange={(e) => setCodigoPDV(e.target.value)}
                        className="font-Roboto border border-solid border-gray-400 text-base rounded-lg p-2"
                        name="codigoPDV"
                        type="text"
                        required={selectedReport !== "retiradaReforco"}
                      />
                    </div>
                  </>
                ) : null}

                <button className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto">
                  <span>Filtrar</span>
                  <FaFilter size={20} />
                </button>
              </div>
            </form>
            <div className="w-full h-full">
              {reportData && reportData.length > 0 ? (
                <div className="flex gap-2 justify-center items-center p-2">
                  <button
                    onClick={handleExportPDF}
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                  >
                    <span>Exportar PDF</span>
                    <FaFilePdf size={20} />
                  </button>
                  <button
                    onClick={() => {
                      xlsComponents[selectedReport]();
                    }}
                    className="flex gap-2 font-[500] items-center rounded-lg text-lg border-none p-3 bg-[#2185D0] text-white transition cursor-pointer hover:bg-[#1A6DA8] font-Roboto"
                  >
                    <span>Exportar XLS</span>
                    <FaFileExcel size={20} />
                  </button>
                </div>
              ) : null}
              {showReportData ? (
                isLoading ? (
                  <Loader />
                ) : (
                  (reportData && reportComponents[selectedReport]?.()) || null
                )
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    </Layout>
  );
}
export default Relatorios;
